import React, { useMemo } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import HospitalCard from './HospitalCard'
import { Hospital } from '../Hospital'

interface HospitalCarouselProps {
  selected: Hospital
  setSelected: (hospital: Hospital) => void
  hospitals: Hospital[]
}
const HospitalCarousel = React.memo(
  ({ selected, setSelected, hospitals }: HospitalCarouselProps) => {
    const selectedItem = useMemo(
      () => hospitals.findIndex(h => h?.key === selected?.key),
      [selected, hospitals]
    )

    const setHospitalSelected = (index: number) => {
      setSelected([...hospitals][index])
    }

    return (
      <Carousel
        selectedItem={selectedItem}
        onChange={setHospitalSelected}
        centerMode
        centerSlidePercentage={80}
        infiniteLoop={false}
        showThumbs={false}
        showIndicators={false}
        showStatus={false}
        swipeable
        emulateTouch
        autoPlay={false}
      >
        {hospitals.map((hospital, i) => (
          <HospitalCard
            key={i}
            hospital={hospital}
            sx={{
              ...(i === 0 ? { ml: [6, 6, 6, 6, 10, 10] } : {}),
              ...(i === hospitals.length - 1
                ? { mr: [6, 6, 6, 6, 10, 10] }
                : {})
            }}
          />
        ))}
      </Carousel>
    )
  }
)

export default HospitalCarousel
